module.exports = __webpack_public_path__ + "media/icons/key-cmd-1-9-281da31c.svg";